import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";

import styled from "styled-components";
import axios from "axios";
import AmbassadorsList from "../tools/AmbassadorsList";

import {AMB_TYPES_NEW} from "./AdminAmbassadorsPanel";

import Select from 'react-select'

import { useNavigate } from "react-router-dom";
import { Control } from "../../ui-kit/control";
import { useTranslation } from "react-i18next";

export default function PublicAllAmbassadorsPanel(props) {

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";

    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedUserId, setSelectedUserId] = useState(undefined);

    const [filterType, setFilterType] = useState(undefined);
    const [filterCity, setFilterCity] = useState(undefined);

    useEffect(() => {
        setLoading(true);
        axios.get("/ambassadors/all").then(d => d.data).then(arr => {
            setUsers(arr);
            setLoading(false);
        });
    }, []);

    let allUniqueCities = users.map(x => x.city).filter(x => (x != undefined && x != '')).filter((v, i, a) => a.indexOf(v) === i);
    console.log('allUniqueCities = ', allUniqueCities);
    let citiesOptions = allUniqueCities.map(x => ({label: x, value: x})).sort((a, b) => {
        let s1 = a.label.toLowerCase();
        let s2 = b.label.toLowerCase();
        if (s1 > s2){
            return 1;
        }
        if (s1 < s2){
            return -1;
        }
        return 0;
    });

    let selectedUser = (selectedUserId == undefined) ? undefined : users.find(x => (x.id == selectedUserId));

    let sortedUsers = users.sort((a, b) => {
        let scoreA = (+a.timestamp + (a.isVip == true ? 10000000000 : 0));
        let scoreB = (+b.timestamp + (b.isVip == true ? 10000000000 : 0));
        return -(scoreA - scoreB);
    });

    sortedUsers = sortedUsers.filter(x => {
        if (x.ambassadorExpirationTimestamp != undefined && +x.ambassadorExpirationTimestamp < +new Date()){
            return false;
        }
        return true;
    });

    // filter
    if (filterType != undefined) {
        sortedUsers = sortedUsers.filter(x => x.ambassadorType == filterType);
    }
    if (filterCity != undefined) {
        sortedUsers = sortedUsers.filter(x => x.city == filterCity);
    }

    console.log("--->> > selectedUserId = ", selectedUserId);
    console.log("--->> > selectedUser = ", selectedUser);
    console.log("--->> > sortedUsers = ", sortedUsers);



    return (
        <Wrapper>

            <div className={'block sm:flex flex-row justify-end mb-10'} >
                <div className={'m-2'} style={{width: '300px'}} >
                    <Select
                        options={AMB_TYPES_NEW}
                        isClearable={true}
                        placeholder={isRu ? 'Статус Амбассадора' : 'Ambassador Type'}
                        value={AMB_TYPES_NEW.find(x => x.value == filterType)}
                        onChange={dd => setFilterType(dd?.value)}
                    />


                </div>
                <div className={'m-2'} style={{width: '300px'}} >
                    <Select
                        isClearable={true}
                        options={citiesOptions}
                        placeholder={isRu ? 'Город' : 'City'}
                        value={citiesOptions.find(x => x.value == filterCity)}
                        onChange={dd => setFilterCity(dd?.value)}
                    />
                    {/*<Control.Select*/}
                    {/*    name="city"*/}
                    {/*    placeholder={'Город'}*/}
                    {/*    options={[{label: 'Почетный', value: 0}, {label: "МедиаАмбассадор", value: 1}, {label: "Обычный", "value": 2}]}*/}
                    {/*    menuProps={{ extra: `> * { max-width: 250px; }` }}*/}
                    {/*/>*/}

                </div>
            </div>

            <ListPlaceholder>
                <AmbassadorsList
                    users={sortedUsers}
                    onSelect={dd => {
                        setSelectedUserId(dd?.id);
                        navigate(`/ambassadors/${dd?.id}`);
                    }}
                />
            </ListPlaceholder>

        </Wrapper>
    );
}

const Wrapper = styled.div`

`;

const ListPlaceholder = styled.div`

`;

const TopPlaceholder = styled.div`
  margin-bottom: 10px;
`;